/* eslint-disable no-unexpected-multiline */
import { useCartStorage } from "../../../store";
import { useMemo, useState } from "react";
import ChainConfirmationModal from "../../common/ConfirmationModal";
import { ChainConfirmationModalBody } from "./ChainConfirmationModalBody";
import { modalDelayMs } from "../../../constants";
import { useAccount, useWalletClient } from "wagmi";
import { groupBy } from "lodash-es";
import MRCProgressModal from "../../common/MRCProgressModal";
import { MRCProgressModalBody } from "./MRCProgressModalBody";
import { useCheckoutStore } from "../../../checkoutStore";
import { getGitcoinRecipientData, useDonateToGitcoin } from "../DonateToGitcoinContext";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function PayoutModals(_ref) {
  let {
    openChainConfirmationModal,
    setOpenChainConfirmationModal,
    openMRCProgressModal,
    setOpenMRCProgressModal,
    rounds,
    enoughBalanceByChainId,
    totalAmountByChainId,
    handleSwap,
    totalDonationAcrossChainsInUSD
  } = _ref;
  const {
    selectedChainId,
    selectedToken,
    directAllocationPoolId,
    amountInWei
  } = useDonateToGitcoin();
  const {
    data: walletClient
  } = useWalletClient();
  const {
    connector
  } = useAccount();
  const {
    checkout
  } = useCheckoutStore();
  const {
    projects
  } = useCartStorage();
  const projectsByChain = useMemo(() => groupBy(projects, "chainId"), [projects]);
  /** The ids of the chains that will be checked out */
  const [chainIdsBeingCheckedOut, setChainIdsBeingCheckedOut] = useState(Object.keys(projectsByChain).map(Number));
  const cancelButtonAction = () => {
    setOpenChainConfirmationModal(false);
    setChainIdsBeingCheckedOut(Object.keys(projectsByChain).map(Number));
  };

  /** We find the round that ends last, and take its end date as the permit deadline */
  const currentPermitDeadline = rounds && rounds.length > 0 ? [...rounds].sort((a, b) => a.roundEndTime.getTime() - b.roundEndTime.getTime())[rounds.length - 1].roundEndTime.getTime() : 0;
  async function handleSubmitDonation() {
    try {
      if (!walletClient || !connector) {
        console.error("Wallet client or Connector not available");
        return;
      }
      setTimeout(() => {
        setOpenMRCProgressModal(true);
        setOpenChainConfirmationModal(false);
      }, modalDelayMs);
      await checkout(chainIdsBeingCheckedOut.filter(chainId => enoughBalanceByChainId[chainId] === true).map(chainId => ({
        chainId,
        permitDeadline: currentPermitDeadline
      })), walletClient, connector, selectedChainId && selectedToken && directAllocationPoolId && amountInWei ? {
        chainId: selectedChainId,
        tokenAddress: selectedToken,
        poolId: directAllocationPoolId.toString(),
        amount: amountInWei,
        recipient: getGitcoinRecipientData(selectedChainId).recipient,
        nonce: getGitcoinRecipientData(selectedChainId).nonce
      } : undefined);
    } catch (error) {
      console.error(error);
    }
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(ChainConfirmationModal, {
      title: "Checkout",
      confirmButtonText: "Checkout",
      confirmButtonAction: handleSubmitDonation,
      cancelButtonAction: cancelButtonAction,
      body: /*#__PURE__*/_jsx(ChainConfirmationModalBody, {
        projectsByChain: projectsByChain,
        totalDonationsPerChain: totalAmountByChainId,
        chainIdsBeingCheckedOut: chainIdsBeingCheckedOut,
        setChainIdsBeingCheckedOut: setChainIdsBeingCheckedOut,
        enoughBalanceByChainId: enoughBalanceByChainId,
        handleSwap: handleSwap,
        totalDonationAcrossChainsInUSD: totalDonationAcrossChainsInUSD
      }),
      isOpen: openChainConfirmationModal,
      setIsOpen: setOpenChainConfirmationModal,
      disabled: chainIdsBeingCheckedOut.length === 0
    }), /*#__PURE__*/_jsx(MRCProgressModal, {
      isOpen: openMRCProgressModal,
      subheading: "Please hold while we submit your donation.",
      body: /*#__PURE__*/_jsx(MRCProgressModalBody, {
        chainIdsBeingCheckedOut: chainIdsBeingCheckedOut.filter(chainId => enoughBalanceByChainId[chainId] === true),
        tryAgainFn: handleSubmitDonation,
        setIsOpen: setOpenMRCProgressModal
      })
    })]
  });
}